/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import uniqid from 'uniqid'
import _ from 'lodash'
var VoiceTab = function (editor) {

    var signals = editor.signals;

    var container = new UI.Panel();
    container.setId('voiceTab');

    var selectedElement = null;
    var selected = null;

    // Voice editor default values
    var defaultVoiceIndex = 25
    var defaultVoiceVolume = 1

    //0.06361 is provided by Z and indicates the amount of time per character when speaking
    var timePerCharacter = 0.06361

    function build() {

        container.clear();

        if (selectedElement === null) return;

        // Voice

        var row = new UI.Row();
        row.add(new UI.Text('Voice').setWidth('90px'));



        
        // start Category
        var row = new UI.Row()
        
        // Start gender selector
        var genderSelector = new UI.Select().setWidth('100px')
        var countrySelector = new UI.Select().setWidth('100px')

        row.add(genderSelector)
        var genders = ['Standard Male', 'Standard Female', 'Wavenet Male', 'Wavenet Female']

        // When firstly created a character, put a default gender
        if (typeof selectedElement.line.gender === 'undefined') {
            selectedElement.line.gender = 'Standard Male'
        }
        // define gender index in select menu
        // when gender is changed, automatically update countries menu list, and set the first country item as default
        // And update selectedElement.line.gender
        // update selectedElement.line.country (index 0 as default)
        // update selectedElement.line.voiceName, the name that is used for voice name block in timeline
        var voiceGenderIndex = genders.findIndex(gender => gender === selectedElement.line.gender)
        genderSelector.setOptions(genders).setValue(voiceGenderIndex)
        genderSelector.onChange( function () {
            let changedVoiceGenderIndex = this.getValue()
            voiceGenderIndex = parseInt(changedVoiceGenderIndex)
            let newGender = genders[parseInt(voiceGenderIndex)]
            selectedElement.line.gender = newGender
            // update countries menu list
            editor.voiceCountriesNodes = editor.voiceItems.filter(item => item.description.includes(newGender))
            editor.voiceCountries = editor.voiceCountriesNodes.map(node => {
                let index = node.description.indexOf(')')
                let country = node.description.substr(0, index + 1)
                return country
            })
            editor.voiceCountries = _.uniq(editor.voiceCountries)
            countrySelector.setOptions(editor.voiceCountries)
            countrySelector.setValue(0)
            selectedElement.line.country = editor.voiceCountries[0]
            let nodesWithGender = editor.voiceItems.filter(item => item.description.includes(selectedElement.line.gender))
            let finalVoiceItem = nodesWithGender.filter(node => node.description.includes(selectedElement.line.country))[0]
            selectedElement.line.voiceName = finalVoiceItem.audio.audioName
            signals.animationModified.dispatch(selected)
        })
        // End gender
        // Start Country selector
        row.add(countrySelector)
        countrySelector.setMargin('0 0px 0 10px')
        editor.voiceCountriesNodes = editor.voiceItems.filter(item => item.description.includes(selectedElement.line.gender))
        editor.voiceCountries = editor.voiceCountriesNodes.map(node => {
            let index = node.description.indexOf(')')
            let country = node.description.substr(0, index + 1)
            return country
        })
        editor.voiceCountries = _.uniq(editor.voiceCountries)        
        // add Trump, Sanders, Warren
        if (selectedElement.line.gender === 'Standard Male') {
            editor.voiceCountries.push('Trump')
            editor.voiceCountries.push('Sanders')
        } else if (selectedElement.line.gender === 'Standard Female') {
            editor.voiceCountries.push('Warren')
        }
        var voiceCountryIndex = editor.voiceCountries.findIndex(country => country === selectedElement.line.country)
        countrySelector.setOptions(editor.voiceCountries).setValue(voiceCountryIndex)
        // When firstly created a character, put a default country of US accent
        if (typeof selectedElement.line.country === 'undefined') {
            countrySelector.setValue(3)
            selectedElement.line.country = editor.voiceCountries[3]
        }
        countrySelector.onChange( function () {
            let changedVoiceCountryIndex = this.getValue()
            voiceCountryIndex = parseInt(changedVoiceCountryIndex)
            let newCountry = editor.voiceCountries[parseInt(voiceCountryIndex)]
            selectedElement.line.country = newCountry
            // parse trump, Sanders, Warren into voiceName
            if (selectedElement.line.country === 'Trump' || selectedElement.line.country === 'Sanders' || selectedElement.line.country === 'Warren' ) {
                selectedElement.line.voiceName = 'en-US-' + selectedElement.line.country
                signals.animationModified.dispatch(selected)
            } else {
                let nodesWithGender = editor.voiceItems.filter(item => item.description.includes(selectedElement.line.gender))
                let finalVoiceItem = nodesWithGender.filter(node => node.description.includes(selectedElement.line.country))[0]
                selectedElement.line.voiceName = finalVoiceItem.audio.audioName
                signals.animationModified.dispatch(selected)
            }
        })
        container.add(row)
        // end country selector
        // end Category
        
        // // Select Voice
        // var row = new UI.Row();
        // row.add(new UI.Text('Voice Selector').setWidth('180px'));
        // container.add(row);

        // var animationVoice = new UI.Select()
        // let animationVoiceIndex = editor.voiceItems.findIndex(voiceItem => voiceItem.audio.audioName === selectedElement.line.voiceName)
        // animationVoice.setOptions(editor.voiceItems.map((voiceItem, i) => voiceItem.audio.audioName)).setValue(animationVoiceIndex);
        // animationVoice.onChange(function (e) {

        //     let changedVoiceSelectionIndex = this.getValue()
        //     animationVoiceIndex = parseInt(changedVoiceSelectionIndex)
        //     let newDescription = editor.voiceItems[parseInt(changedVoiceSelectionIndex)].audio.audioName
        //     selectedElement.line.voiceName = newDescription


        //     //TODO maybe add signal here???
        // });
        // row.add(animationVoice);

        //Select Voice Text
        var row = new UI.Row();
        row.add(new UI.Text('Voice Text').setWidth('180px'));
        container.add(row);

        
        // text to speech textarea
        var row = new UI.Row();
        var input = new UI.TextArea().setWidth('100%')
        input.setValue(selectedElement.line.text)
        input.setHeight('100%')
        input.setBackground('#444')
        input.setBorderStyle('solid')

        input.dom.addEventListener('input', function (e) {
            let val = e.target.value
            if (val !== selectedElement.line.text) {
                e.target.style.borderColor = 'yellow'
            } else {
                e.target.style.borderColor = 'rgb(97, 97, 97)'
            }
        })

        input.onChange(function (e) {
            console.log(this.getValue())
            let changedVoiceText = this.getValue()
            selectedElement.line.endTime = determineVoiceElementEndTime(changedVoiceText, selectedElement.line.startTime)
            selectedElement.line.text = changedVoiceText
            pushElementsAfter(selectedElement)
            signals.animationModified.dispatch(selected);

            //hacky
            e.target.style.borderColor = 'rgb(97, 97, 97)'
        });
        row.add(input);

        // text to speech button
        var audioOfTextArea = new Audio()
        var textSpeechButton = new UI.Button();
        textSpeechButton.setBackground('url(../static/files/play.svg)');
        textSpeechButton.setWidth('20px');
        textSpeechButton.setHeight('20px');
        textSpeechButton.onClick(function () {
            let nodesWithGender = editor.voiceItems.filter(item => item.description.includes(selectedElement.line.gender))
            let finalVoiceItem = nodesWithGender.filter(node => node.description.includes(selectedElement.line.country))[0]
            let voiceName = finalVoiceItem.name
            console.log("playing text to speech")
            // realtime text is :   selectedElement.line.text
            // realtime voice is:   editor.voiceItems[animationVoiceIndex].name			
            let data = {
                "audioConfig": {
                    "audioEncoding": "LINEAR16",
                    "pitch": 0,
                    "speakingRate": 1
                },
                "input": {
                    "text": selectedElement.line.text
                },
                "voice": {
                    "languageCode": voiceName.substr(0, 5),
                    "name": voiceName
                }
            }
            if (data.voice.name.substr(0, 5) !== 'en-US') {
                console.log("Please select en-US voice")
            }
            let dataToSend = JSON.stringify(data)
            let url = 'https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyBWLXM2n0Fs5-qWi8vKz1kJ2_VcOeGVzVs'
            let dataRecieved = "";
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: dataToSend
            })
                .then(resp => {
                    if (resp.status == 200) {
                        return resp.json()
                    } else {
                        console.log("Status: " + resp.status);
                        return Promise.reject("server")
                    }
                })
                .then(dataJson => {
                    console.log(dataJson)
                    audioOfTextArea.src = 'data:audio/ogg;base64,' + dataJson.audioContent
                    audioOfTextArea.play()
                })
                .catch(err => {
                    if (err == "server") return
                    console.log("The error is :" + err);
                })
        })
        row.add(textSpeechButton);
        container.add(row);

        // Pause text to speech button
        var textSpeechPauseButton = new UI.Button();
        textSpeechPauseButton.setBackground('url(../static/files/pause.svg)');
        textSpeechPauseButton.setWidth('20px');
        textSpeechPauseButton.setHeight('20px');
        textSpeechPauseButton.onClick(function () {
            audioOfTextArea.pause()
        })
        row.add(textSpeechPauseButton);

        container.add(row);

        //Enter Voice Volume
        var row = new UI.Row();
        row.add(new UI.Text('Voice Volume').setWidth('180px'));
        container.add(row);

        var voiceVolume = new UI.Number(selectedElement.line.voiceVolume).setWidth('80px');
        voiceVolume.onChange(function (e) {

            let voiceVolume = this.getValue();
            selectedElement.line.voiceVolume = voiceVolume

        });
        row.add(voiceVolume);

        //Enter Voice Start
        var row = new UI.Row();
        
        
        row.add(new UI.Text('Voice Start').setWidth('180px'));
        container.add(row);

        var voiceStart = new UI.Text(selectedElement.line.startTime).setWidth('80px');
        voiceStart.onChange(function (e) {

            let volumeStartTime = this.getValue();

            if (volumeStartTime >= selected.start) {
                selectedElement.line.startTime = volumeStartTime
                signals.animationModified.dispatch(selected);
            }

        });
        row.add(voiceStart);
        var row = new UI.Row();
        row.add(new UI.Text('API Calls').setWidth('180px'));
        container.add(row);

        // Showing List of API Calls
        var row = new UI.Row();
        var apiContainer = new UI.Panel();
        apiContainer.setBorder('1px solid #fff').setMargin('25px').setBorderRadius('8px').setPadding('0px')
        container.add(apiContainer);

        row.add(new UI.Text('Demographic').setWidth('100%').setBackground('rgb(158,65,65,0.1)').setMargin('10px 0').setPadding('10px 0'));

        row.add(new UI.Text('#date').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#gender').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#temperature').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#age').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));

        row.add(new UI.Text('News').setWidth('100%').setBackground('rgb(158,65,65,0.1)').setMargin('10px 0').setPadding('10px 0'));

        row.add(new UI.Text('#arts_headline').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#book_headline').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));

        row.add(new UI.Text('Facial Feature').setWidth('100%').setBackground('rgb(158, 65, 65, 0.1)').setMargin('10px 0').setPadding('10px 0'));

        row.add(new UI.Text('#glasses').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#moustache').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#eyeMakeup').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        
        row.add(new UI.Text('Emotions').setWidth('100%').setBackground('rgb(158,65,65,0.1)').setMargin('10px 0').setPadding('10px 0'));

        
        row.add(new UI.Text('#anger').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#fear').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#contempt').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#happiness').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#surprise').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#sadness').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        row.add(new UI.Text('#disgust').setWidth('80%').setTextTransform('lowercase').setFontSize('13px').setBorderRadius('20px').setBorder('1px solid #fff').setMargin('1% 1%').setPadding('5px').setTextAlign('center').setBackground('rgb(280,2805,280,0.05)'));
        apiContainer.add(row).setTextAlign('center').setOverflow('scroll');


        

        // Add Voice
        var row = new UI.Row();
        var voiceContainer = new UI.Div()
        var button = new UI.Button('Add New Voice').setWidth('100%')

        button.onClick(function () {
            let newVoice =_addNewVoiceElement(selected)
            signals.animationModified.dispatch(selected);
            signals.animationSubComponentSelected.dispatch(newVoice, selected)
        });
        row.add(voiceContainer);
        row.add(button);
        container.add(row);

        // Remove Voice
        // Only display if there are multiple voices
        if (selected.elements.filter(element => element.line).length > 1) {
            var row = new UI.Row();
            var voiceContainer = new UI.Div()
            var button = new UI.Button('Remove This Voice').setWidth('100%')

            button.onClick(function () {
                selected.elements = selected.elements.filter(element => element != selectedElement)
                signals.animationModified.dispatch(selected);
                signals.animationSelected.dispatch(null);
            });
            row.add(voiceContainer);
            row.add(button);
            container.add(row);

        }
    }

    function pushElementsAfter(element) {
        let lineElement = element.line
        let lineIndex = selected.elements.findIndex(el => el === element)

        let elementsToShift = selected.elements.filter((el, i) => el.line && i > lineIndex && lineElement.endTime > el.line.startTime)

        let nextStart = lineElement.endTime

        elementsToShift.forEach(el => {
            let orgDuration = el.line.endTime - el.line.startTime
            el.line.startTime = nextStart
            el.line.endTime = el.line.startTime + orgDuration
            nextStart = el.line.endTime
        })
        if (selected.end < nextStart) {
            selected.end = nextStart
        }
    }

    function determineVoiceElementEndTime(text, startTime) {
        let timeForText = (text.length * timePerCharacter) + 1
        return startTime + timeForText
    }

    function determineNewVoiceElementStartTime(text) {
        let lastEndTime = 0
        selected.elements.forEach(element => {
            if (!element.line) return
            
            if (lastEndTime < element.line.endTime) {
                lastEndTime = element.line.endTime
            }
        })

        return lastEndTime
    }

    // note this method is duplicated in SettingTab.js
    function _addNewVoiceElement(selected) {
        let text = "Enter Voice Text"
        let startTime = determineNewVoiceElementStartTime(text)
        let endTime = determineVoiceElementEndTime(text, startTime)
        let elementToAdd = {
            id: uniqid(),
            line: {
                type: "Specific",
                text: text,
                startTime: startTime,
                endTime: endTime,
                voiceName: editor.voiceItems[defaultVoiceIndex].audio.audioName,
                voiceEffect: "None",
                voiceVolume: defaultVoiceVolume
            }
        }
        if (selected.end < endTime) {
            selected.end = endTime
        }
        selected.elements.push(elementToAdd)
        return elementToAdd
    }

    signals.animationSubComponentSelected.add(function (el, animation) {
        if (el.line) {
            selectedElement = el;
            selected = animation;
            build();
        }
    });

    signals.animationModified.add(function (animation) {
        selected = animation;
        build();
    });


    signals.effectCompiled.add(build);

    return container;

};

export default VoiceTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/VoiceTab.js
// module id = null
// module chunks = 